import _extends from "babel-runtime/helpers/extends";
import _regeneratorRuntime from "babel-runtime/regenerator";
import _asyncToGenerator from "babel-runtime/helpers/asyncToGenerator";
import _JSON$stringify from "babel-runtime/core-js/json/stringify";
import _Promise from "babel-runtime/core-js/promise";
import _Object$assign from "babel-runtime/core-js/object/assign";
import sysConfig from "../config/sysConfig.js";
import definecfg from "../config/defineConfig.js";
import { isObject } from "util";
import dateFormat from "../tools/format.js";
import storage from "../tools/storage.js";
import dict from "../tools/dict";
import store from "../vuex";
import baseConfig from "../config/baseConfig";
import bizcfg from "../config/bizConfig";
import types from "@/vuex/mutation-types";

export default {
  handleWithErrorMsg: function handleWithErrorMsg(msg) {
    try {
      var reg = new RegExp("【(.*)】", "m");
      var msgError = msg.match(reg),
          newMsgErr = msgError.length && msgError[1];
      if (newMsgErr && reg.test(newMsgErr)) {
        return this.handleWithErrorMsg(newMsgErr);
      } else {
        return newMsgErr;
      }
    } catch (err) {
      return msg;
    }
  },
  updateSessionBusiNameAndDef: function updateSessionBusiNameAndDef(busiCode) {
    return this.getBusiDefInfo(busiCode).then(function (data) {
      if (!_.isEmpty(data)) {
        storage.$storage.setSession(definecfg.$definecfg.BUSI_DEF_INFO, data || {});
        storage.$storage.setSession(definecfg.$definecfg.BUSI_SCOPE, data.BUSI_SCOPE || "2");

        storage.$storage.setSession(definecfg.$definecfg.BUSI_NAME, data.BUSI_NAME.replace("VTM-", ""));
        store.commit(types.$types.UPDATE_BUSI_CODE, busiCode);
        return data;
      }
    });
  },

  getSysDate: function getSysDate() {
    return sysConfig.$syscfg.K_Request("F0000000", { SERVICE_CODE: "P9999997" }).then(function (data) {
      return data && data.Data && data.Data[0].length && data.Data[0][0].DB_DATE || "";
    });
  },

  getOppBusiData: function getOppBusiData(B_SNO, isAceept) {
    var that = this;
    if (!B_SNO) {
      throw "流水号不能为空";
    }
    return sysConfig.$syscfg.K_Request("F0000036", {
      B_SNO: B_SNO
    }).then(function (data) {
      var oppBusiData = data && data.Data && data.Data.length && data.Data[0] || {};
      return that.parseAcceptParam(oppBusiData, isAceept);
    });
  },
  getBusiDataByApptSn: function getBusiDataByApptSn(apptSn) {
    var _this = this;

    if (!apptSn) {
      throw "预约号不能为空";
    }

    return sysConfig.$syscfg.K_Request("QSA160011", { APPT_SN: apptSn }).then(function (res) {
      if (res.Code == 0) {
        var data = res.Data[0];
        if (data.B_SNO) {
          vm.$store.commit(vm.$types.UPDATE_B_SNO, data.B_SNO);
          return _this.getOppBusiData(data.B_SNO, true).then(function (busiData) {
            vm.$storage.setSession(vm.$definecfg.BUSI_INFO, _Object$assign({}, busiData));
            return busiData;
          });
        }
      } else {
        alert(res.Msg || "获取数据失败,请重试！");
        return false;
      }
    });
  },
  parseAcceptParam: function parseAcceptParam(data, isAceept) {
    var acceptParams = data.ACCEPT_PARAM && JSON.parse(decodeURIComponent(data.ACCEPT_PARAM)) || {};
    var busiData = isAceept ? acceptParams : _Object$assign({}, data, acceptParams);

    store.commit(types.$types.UPDATE_OLD_BIZ_DATA, _.cloneDeep(_Object$assign({}, data, acceptParams)));
    delete busiData.ACCEPT_PARAM;
    delete busiData.DEAL_PARAM;
    if (!_.isEmpty(busiData)) {
      return busiData;
    } else {
      return {};
    }
  },

  getBusiDefInfo: function getBusiDefInfo(busiCode) {
    return new _Promise(function (resolve, reject) {
      if (!busiCode) {
        throw "调用getBusiDefInfo方法，busicode【业务代码】没有传入！";
        reject(busiCode);
      }
      sysConfig.$syscfg.K_Request("F0000029", {
        BUSI_CODE: busiCode
      }).then(function (data) {
        resolve(data && data.Data && data.Data.length && data.Data[0]);
      }).catch(function (err) {
        reject(err);
      });
    });
  },

  getOpUserInfo: function getOpUserInfo(userCode) {
    return new _Promise(function (resolve, reject) {
      if (!userCode) {
        throw "调用getOpUserInfo方法，必要参数userCode【操作员代码】没有传入！";
        reject(userCode);
      }
      sysConfig.$syscfg.K_Request("W0000116", {
        USER_CODE: userCode
      }).then(function (data) {
        resolve(data && data.Data && data.Data.length && data.Data[0] || {});
      }).catch(function (err) {
        reject(err);
      });
    });
  },

  getCustSysInYmtInfo: function getCustSysInYmtInfo(custCode) {
    return new _Promise(function (resolve, reject) {
      if (!custCode) {
        throw "调用getCustSysInYmtInfo方法，必要参数custCode【客户代码】没有传入！";
        reject(custCode);
      }
      sysConfig.$syscfg.K_Request("W0000119", {
        bex_codes: "L2100417",
        CUST_CODE: custCode
      }).then(function (data) {
        resolve(data && data.Data && data.Data.length && data.Data || []);
      }).catch(function (err) {
        reject(err);
      });
    });
  },

  getAcctGeneralQueryYmtInfo: function getAcctGeneralQueryYmtInfo(custCode) {
    var _arguments = arguments;

    return new _Promise(function (resolve, reject) {
      if (!custCode) {
        throw "调用getAcctGeneralQueryYmtInfo方法，必要参数custCode【客户代码】没有传入！";
        reject(_arguments);
      }
      sysConfig.$syscfg.K_Request("Y3000045", {
        F_FUNCTION: "980105030",
        p_gnbh: "980105030",
        QUERY_MODE: "QUERY",
        CUST_CODE: custCode,
        USER_CODE: custCode,
        CUSTID: custCode,
        SYS_CUST_NO: custCode
      }).then(function (data) {
        resolve(data && data.Data && data.Data.length && data.Data[0] || {});
      }).catch(function (err) {
        reject(err);
      });
    });
  },

  queryTrdacctBizInfo: function queryTrdacctBizInfo(param) {
    var _arguments2 = arguments;

    return new _Promise(function (resolve, reject) {
      if (!param) {
        throw "调用queryTrdacctBizInfo方法，参数不正确！";
        reject(_arguments2);
      }
      sysConfig.$syscfg.K_Request("W0000119", {
        bex_codes: "YGT_A2100027",
        EXTERNAL_SN: param.EXTERNAL_SN,
        ACCTBIZ_EXCODE: param.ACCTBIZ_EXCODE,
        INT_ORG: param.INT_ORG,
        BGN_DATE: param.OCCUR_DATE,
        END_DATE: param.OCCUR_DATE
      }).then(function (data) {
        resolve(data && data.Data && data.Data.length && data.Data[0] || {});
      }).catch(function (err) {
        reject(err);
      });
    });
  },

  getBizFields: function getBizFields() {
    return sysConfig.$syscfg.K_Request("F0000035").then(function (data) {
      var filterFields = [];
      _.each(data.Data, function (obj) {
        if (obj.COLUMN_NAME !== "ACCEPT_PARAM" && obj.COLUMN_NAME !== "DEAL_PARAM") {
          filterFields.push(obj.COLUMN_NAME);
        }
      });
      return filterFields;
    });
  },
  parseParam: function parseParam(fields, param) {
    var pkgParam = void 0,
        normalParam = {};
    pkgParam = _.pickBy(param, function (v, k) {
      if (-1 === _.indexOf(fields, k)) {
        return true;
      }
      normalParam[k] = v;
      return false;
    });

    return {
      pkgParam: pkgParam,
      normalParam: normalParam
    };
  },

  carryOutBizData: function carryOutBizData(param, isAccept, procStatus) {
    var that = this,
        B_SNO = storage.$storage.getSession(definecfg.$definecfg.B_SNO),
        customerInfo = storage.$storage.getJsonSession(definecfg.$definecfg.CUSTOMER_INFO) || {},
        isDoubleRecord = storage.$storage.getSession(definecfg.$definecfg.IS_DOUBLE_RECORD) == 1,
        userInfo = storage.$storage.getJsonSession(definecfg.$definecfg.USER_INFO) || {};
    return that.getBizFields().then(function (fields) {
      var newParsedObj = that.parseParam(fields, param),
          newPkgParam = newParsedObj.pkgParam,
          newNormalParam = newParsedObj.normalParam,
          mustUpdateData = {
        CUST_ORG_CODE: param.CUST_ORG_CODE,
        OP_ORG: userInfo.ORG_CODE,
        ORG_CODE: customerInfo.INT_ORG,
        PROC_STATUS: procStatus,
        YZT_CHANNEL: sysConfig.$syscfg.getYztChannel(),
        HANDLE_CODE: userInfo.OP_CODE,
        OP_CODE: userInfo.OP_CODE,
        APPT_SN: storage.$storage.getSession(definecfg.$definecfg.APPT_SN) || "" };
      _Object$assign(newNormalParam, mustUpdateData);
      !newNormalParam.B_SNO && (newNormalParam.B_SNO = B_SNO);
      if (newNormalParam.B_SNO) {
        return that.getOppBusiData(newNormalParam.B_SNO, isAccept).then(function (data) {
          var parsedObj = that.parseParam(fields, data || {}),
              pkgParam = parsedObj.pkgParam;

          if (!_.isEmpty(newPkgParam) && !_.isEqual(pkgParam, newPkgParam)) {
            newNormalParam[isAccept ? "ACCEPT_PARAM" : "DEAL_PARAM"] = encodeURIComponent(_JSON$stringify(_.extend(pkgParam, newPkgParam)));
            newNormalParam["OP_START_TIME"] = param.OP_START_TIME || "";
          }
          return that.F0000015(newNormalParam);
        });
      } else {
        consoleLog("流水号为空，创建新流水");
      }

      if (!_.isEmpty(newPkgParam)) {
        newNormalParam[isAccept ? "ACCEPT_PARAM" : "DEAL_PARAM"] = encodeURIComponent(_JSON$stringify(newPkgParam));
        newNormalParam["OP_START_TIME"] = param.OP_START_TIME || "";
      }

      return that.F0000015(newNormalParam);
    });
  },
  F0000015: function F0000015(newParams) {
    newParams.OP_CHANNEL = "13";
    return sysConfig.$syscfg.K_Request("F0000015", newParams);
  },
  saveBizData: function saveBizData() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var _this2 = this;

    var bdata = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var apptStatus = arguments[2];
    return _asyncToGenerator(_regeneratorRuntime.mark(function _callee() {
      var B_SNO, res, data;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!["QS138", "QS139"].includes(vm.$store.busiCode)) {
                _context.next = 4;
                break;
              }

              consoleLog("存量已完结旧流水QS138Q,S139禁止修改流水表数据,否则数据转换必定失败");
              alert("存量已完结旧流水禁止修改");
              throw "存量已完结旧流水禁止修改";

            case 4:
              B_SNO = storage.$storage.getSession(definecfg.$definecfg.B_SNO);

              if (B_SNO) {
                _context.next = 11;
                break;
              }

              _context.next = 8;
              return vm.$syscfg.K_Request("QSA160011", { APPT_SN: vm.$store.state.apptSn });

            case 8:
              res = _context.sent;
              data = res.Data[0];

              vm.$store.commit(vm.$types.UPDATE_B_SNO, data.B_SNO || "");

            case 11:
              return _context.abrupt("return", _this2.saveOppBusiData(params, bdata).then(function () {
                if (!apptStatus) {
                  apptStatus = vm.$store.state.apptStatus || "1";
                }

                if (["3"].includes(apptStatus)) {
                  apptStatus = "1";
                }
                return _this2.saveOppApptData(params, apptStatus);
              }));

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }))();
  },

  saveOppBusiData: function saveOppBusiData() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var bData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};


    var that = this,
        userInfo = storage.$storage.getJsonSession(definecfg.$definecfg.USER_INFO) || {},
        customerInfo = storage.$storage.getJsonSession(definecfg.$definecfg.CUSTOMER_INFO) || {},
        B_SNO = storage.$storage.getSession(definecfg.$definecfg.B_SNO),
        busiInfo = storage.$storage.getJsonSession(definecfg.$definecfg.BUSI_INFO) || {},
        busiName = storage.$storage.getSession(definecfg.$definecfg.BUSI_NAME),
        orgCurrentAgent = storage.$storage.getJsonSession(definecfg.$definecfg.ORG_CURRENT_AGENT) || {},
        isAgent = store.state.busicode && store.state.busicode == "V0087" ? "1" : _.isEmpty(orgCurrentAgent) ? "0" : "1";
    var procStatus = bData.procStatus;
    var orgOutSideBaseData = {
      LEGAL_REP_TYPE: customerInfo.LEGAL_REP_TYPE || ""
    };
    if (sysConfig.$syscfg.isOpenAcctBiz(store.state.busicode)) {
      if (params.IS_AGENT) {
        orgOutSideBaseData.IS_AGENT = params.IS_AGENT;
      }
    } else {
      orgOutSideBaseData.IS_AGENT = isAgent;
    }

    var flowProcStatus = sysConfig.$syscfg.getFlowModel();

    var getNewValue = function getNewValue(key) {
      return bData && bData[key] || params && params[key] || busiInfo && busiInfo[key] || customerInfo && customerInfo[key] || "";
    };

    var outsideData = {
      SZORG_TYPE: getNewValue("SZORG_TYPE"),

      SUBJECT_IDENTITY: getNewValue("SUBJECT_IDENTITY"),

      OP_ORG: userInfo.ORG_CODE,
      OP_ORG_CODE: userInfo.ORG_CODE,
      ORG_CODE: getNewValue("INT_ORG"),
      NODE_CODE: (bData.NODE_CODE || store.state.bizRouteIndex || "1").toString(),
      EXT_COL5: "9",
      EXT_COL6: getNewValue("PRO_CLS"),

      PROC_STATUS: procStatus || (busiInfo.PROC_STATUS == "11" ? "01" : busiInfo.PROC_STATUS) || flowProcStatus,
      YZT_CHANNEL: sysConfig.$syscfg.getYztChannel(),
      HANDLE_CODE: userInfo.OP_CODE,
      BUSI_CODE: store.state.busicode,
      USER_TYPE: customerInfo.USER_TYPE || store.state.usertype,
      ID_TYPE: customerInfo.ID_TYPE,
      ID_CODE: customerInfo.ID_CODE,
      OP_CODE: userInfo.OP_CODE,
      CUST_CODE: getNewValue("CUST_CODE"),
      CUST_FNAME: customerInfo.USER_FNAME || customerInfo.CUST_FNAME,
      CUST_NAME: customerInfo.CUST_NAME,
      APPT_SN: storage.$storage.getSession(definecfg.$definecfg.APPT_SN) || "",
      VERSION: "base-v" };

    if (bData.YZT_RISK_FACTOR != undefined) {
      outsideData.YZT_RISK_FACTOR = bData.YZT_RISK_FACTOR;
    }
    if (sysConfig.$syscfg.isOpenAcctBiz(store.state.busicode)) {
      delete outsideData.CUST_CODE;
    }

    if (outsideData.NODE_CODE == -1) {
      delete outsideData.NODE_CODE;
      delete bData.NODE_CODE;
    }
    _Object$assign(params, bData, outsideData);

    outsideData.USER_TYPE != "0" && _Object$assign(params, orgOutSideBaseData);

    if (_.includes(["000000", "100223"], baseConfig.$basecfg.qsVersion)) {
      var BUSI_DEF_INFO = storage.$storage.getJsonSession(definecfg.$definecfg.BUSI_DEF_INFO) || {};
      params.PROCESS_KEY = BUSI_DEF_INFO.PROCDEF_KEY || "";
    }

    consoleLog("手机端保存忽略Node_code,流水号：" + B_SNO + "流水状态为：" + params.PROC_STATUS);
    var cloneParams = _.cloneDeep(params);
    return sysConfig.$syscfg.K_Request_ALL([that.carryOutBizData(cloneParams, true, params.PROC_STATUS)]).then(function (data) {
      if (data[0].Code != "0") {
        throw data[0].Msg;
        return [];
      }
      var newbsno = B_SNO || data[0] && data[0].Data.length && data[0].Data[0].B_SNO;
      if (!newbsno) {
        consoleLog("调用一柜通 F0000015接口异常，未获取到流水号数据！");
        return {
          Code: "-9999",
          Msg: "调用一柜通 F0000015接口异常，未获取到流水号数据！",
          Data: []
        };
      } else {
        consoleLog("调用一柜通 F0000015接口正常，流水号为=", newbsno);
      }

      vm.$store.commit(vm.$types.UPDATE_B_SNO, newbsno);
      return that.getOppBusiData(newbsno, true).then(function (busiData) {
        storage.$storage.setSession(definecfg.$definecfg.BUSI_INFO, _Object$assign({}, busiData));
        return newbsno;
      });
    }).catch(function (err) {
      throw err;
      return [];
    });
  },
  saveOppApptData: function saveOppApptData() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var apptStatus = arguments[1];

    var apptSn = params.APPT_SN || storage.$storage.getSession(definecfg.$definecfg.APPT_SN);
    var openAcctType = params.OPEN_ACCT_TYPE || store.state.openAcctType;
    var bSno = storage.$storage.getSession(definecfg.$definecfg.B_SNO);
    var customerInfo = storage.$storage.getJsonSession(definecfg.$definecfg.CUSTOMER_INFO);
    var userInfo = storage.$storage.getJsonSession(definecfg.$definecfg.USER_INFO) || {};
    if (!openAcctType) {
      vm.alert("开户申请类型不能为空");
      throw "开户申请类型不能为空";
    }
    if (!apptStatus) {
      vm.alert("见证状态不能为空");
      throw "见证状态不能为空！";
    }
    var apptTableFieds = {
      APPT_BUSI_CODE: store.state.busicode || "",
      APPT_ORG_CODE: userInfo.ORG_CODE || "",
      APPT_REMARK: "",
      B_SNO: bSno || "",
      APPT_STATUS: apptStatus || "",
      APPT_WAY: "",
      CUACCT_CODE: customerInfo.CUACCT_CODE || "",
      CUST_CODE: customerInfo.CUST_CODE || "",
      CUST_FNAME: customerInfo.CUST_FNAME || customerInfo.USER_FNAME || "",
      CUST_NAME: customerInfo.CUST_NAME || customerInfo.USER_NAME || "",
      CUST_ORG_CODE: customerInfo.INT_ORG || customerInfo.CUST_ORG_CODE || "",
      ID_CODE: customerInfo.ID_CODE || "",
      ID_TYPE: customerInfo.ID_TYPE || "",
      IS_REVIEW: "1",
      IS_DELETE: "0",
      OP_CODE: userInfo.OP_CODE || "",
      OPEN_ACCT_TYPE: openAcctType || ""
    };
    if (!_.isEmpty(apptSn)) {
      apptTableFieds.APPT_SN = apptSn;
    }
    consoleLog("保存预约数据" + apptSn + "预约状态为：" + apptStatus);
    return sysConfig.$syscfg.K_Request("F0000016", apptTableFieds).then(function (data) {
      if (_.isEmpty(apptSn)) {
        var newApptSn = _.get(data, "Data[0].APPT_SN");
        store.commit(types.$types.UPDATE_APPT_SN, newApptSn);
        store.commit(types.$types.UPDATE_APPT_STATUS, apptStatus);
      }
      return {
        Code: "0",
        Msg: "预约成功",
        Data: []
      };
    });
  },
  updateApptStatus: function updateApptStatus(apptSn, apptStatus, bSno) {
    consoleLog("更新预约表流水状态,apptsn=" + apptSn + ",apptstatus=" + apptStatus);
    if (!apptSn) {
      apptSn = storage.$storage.getSession(definecfg.$definecfg.APPT_SN);
    }
    if (!apptSn || _.isEmpty(apptSn)) {
      vm.alert("更新预约流水状态失败,预约号不能为空");
      return _Promise.reject(false);
    }
    bSno = bSno || storage.$storage.getSession(definecfg.$definecfg.B_SNO);
    var serviceCode = bSno ? "QSA160017" : "QSA160006";
    var param = {
      APPT_SN: apptSn,
      APPT_STATUS: apptStatus
    };
    if (bSno) {
      param.B_SNO = bSno;
    }
    return sysConfig.$syscfg.K_Request(serviceCode, param).then(function (res) {
      if (res.Code == "0") {
        store.commit(types.$types.UPDATE_APPT_STATUS, apptStatus);
      }
      return res;
    });
  },
  updateNodeCode: function updateNodeCode(nodeCode) {
    if (!nodeCode) {
      nodeCode = (store.state.bizRouteIndex || "1").toString();
    }
    var B_SNO = storage.$storage.getSession(definecfg.$definecfg.B_SNO);
    if (!B_SNO) {
      consoleLog("流水号为空，无法更新流水");
      return _Promise.resolve(false);
    }
    consoleLog("仅更新业务流水NODE_CODE,bsno=" + B_SNO + ",nodeCode=" + nodeCode);
    return sysConfig.$syscfg.K_Request("Y1001032", {
      B_SNO: B_SNO,
      NODE_CODE: nodeCode
    }).then(function (res) {
      if (res.Code == "0") {
        return true;
      }
    });
  },
  cancelBiz: function cancelBiz(bSno) {
    var _this3 = this;

    return _asyncToGenerator(_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              consoleLog("更新流水状态,bsno=" + bSno);

              if (bSno) {
                _context2.next = 4;
                break;
              }

              vm.alert("作废业务流水状态失败,流水号不能为空");
              return _context2.abrupt("return", _Promise.reject(false));

            case 4:
              return _context2.abrupt("return", sysConfig.$syscfg.K_Request("P001003656", {
                B_SNO: bSno
              }));

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this3);
    }))();
  },
  cancelBiz2: function cancelBiz2(bSno, remark) {
    var _this4 = this;

    return _asyncToGenerator(_regeneratorRuntime.mark(function _callee3() {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              consoleLog("更新流水状态,bsno=" + bSno);

              if (bSno) {
                _context3.next = 4;
                break;
              }

              vm.alert("作废业务流水状态失败,流水号不能为空");
              return _context3.abrupt("return", _Promise.reject(false));

            case 4:
              return _context3.abrupt("return", sysConfig.$syscfg.K_Request("Y1001169", {
                B_SNO: bSno,
                PROC_STATUS: "15",
                APP_REMARK: remark
              }));

            case 5:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this4);
    }))();
  },

  saveMobileData: function saveMobileData() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var IS_MERGE = arguments[1];

    var customerInfo = storage.$storage.getJsonSession(definecfg.$definecfg.CUSTOMER_INFO);
    var bSno = storage.$storage.getSession(definecfg.$definecfg.B_SNO);
    var userInfo = storage.$storage.getJsonSession(definecfg.$definecfg.USER_INFO) || {};
    if (!bSno) {
      alert("保存手机数据失败，流水号为空");
      return _Promise.resolve(false);
    }
    var data = {
      B_SNO: bSno || "",
      BUSI_CODE: store.state.busicode || "",
      CUST_CODE: customerInfo.CUST_CODE || "",
      OP_CODE: userInfo.OP_CODE || ""
    };
    if (!_.isEmpty(params)) {
      data.ACCEPT_PARAM = encodeURIComponent(_JSON$stringify(params));
    }
    if (IS_MERGE == "0" || IS_MERGE == "1") {
      data.IS_MERGE = IS_MERGE;
    }
    consoleLog("保存风测临时表数据" + bSno + "合并标志" + data.IS_MERGE + "");
    return sysConfig.$syscfg.K_Request("F0000090", data).then(function (res) {
      if (res.Code == "0") {
        return true;
      } else {
        consoleLog("保存更新风险测评数据失败！" + res.Msg);
        alert("保存更新风险测评数据失败！" + res.Msg);
      }
    });
  },
  getMobileData: function getMobileData(bSno) {
    return sysConfig.$syscfg.K_Request("F0000089", {
      B_SNO: bSno || "",
      IS_MERGE: "0"
    }).then(function (res) {
      if (res.Code == "0" && _.get(res, "Data[0].ACCEPT_PARAM")) {
        return { flag: true, mergeData: JSON.parse(decodeURIComponent(_.get(res, "Data[0].ACCEPT_PARAM"))) };
      } else {
        return { flag: false };
      }
    });
  },
  mergeMobileData: function mergeMobileData() {
    var _this5 = this;

    return _asyncToGenerator(_regeneratorRuntime.mark(function _callee4() {
      var bSno, _ref, flag, mergeData, busiInfo, res;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              bSno = storage.$storage.getSession(definecfg.$definecfg.B_SNO);

              if (bSno) {
                _context4.next = 4;
                break;
              }

              alert("合并手机数据失败，流水号为空");
              return _context4.abrupt("return");

            case 4:
              _context4.next = 6;
              return _this5.getMobileData(bSno);

            case 6:
              _ref = _context4.sent;
              flag = _ref.flag;
              mergeData = _ref.mergeData;

              if (!(flag && mergeData)) {
                _context4.next = 18;
                break;
              }

              consoleLog("开始合并数据");
              busiInfo = storage.$storage.getJsonSession(definecfg.$definecfg.BUSI_INFO);

              busiInfo.BIZ_DATA = _extends({}, busiInfo.BIZ_DATA, mergeData.BIZ_DATA);
              _context4.next = 15;
              return _this5.saveBizData(_.cloneDeep(busiInfo), { NODE_CODE: -1 });

            case 15:
              res = _context4.sent;
              _context4.next = 19;
              break;

            case 18:
              return _context4.abrupt("return", false);

            case 19:
              return _context4.abrupt("return", _this5.saveMobileData({}, "1"));

            case 20:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this5);
    }))();
  },
  getOppOrgInfo: function getOppOrgInfo(orgCode) {
    return new _Promise(function (resolve, reject) {
      if (!orgCode) {
        throw "调用getOppOrgInfo方法失败，原因：未传入orgCode参数！";
        reject(arguments);
      }
      sysConfig.$syscfg.K_Request("YG000200", {
        ORG_CODE: orgCode
      }).then(function (data) {
        if (data.Code != 0) {
          reject(data);
        } else {
          resolve(data.Data[0]);
        }
      }).catch(function (data) {
        reject(data);
      });
    });
  },
  rejectBusiToPreAccept: function rejectBusiToPreAccept(bsno) {
    return sysConfig.$syscfg.K_Request("W0000120", {
      B_SNO: bsno
    }).then(function () {
      return {
        Code: "0",
        Data: [],
        Message: "流水号【" + bsno + "】驳回至预受理状态成功"
      };
    });
  },

  transDiffData: function transDiffData(obj) {
    var that = this;
    if (!_.isPlainObject(obj)) {
      return;
    }
    obj.DIFF_INFO = [];
    _.forEach(obj, function (value, key) {
      if (_.isPlainObject(value) && (_.has(value, "newVal") || _.has(value, "oldVal")) && (value.newVal || value.oldVal)) {
        obj.DIFF_INFO.push({
          "FIELD": key,
          "OLD": value.oldVal,
          "NEW": value.newVal
        });
        obj[key] = value.newVal;
      } else if (_.isPlainObject(value) && !_.has(value, "newVal") && !_.has(value, "oldVal")) {
        that.transDiffData(value);
      } else if (_.isArray(value)) {
        _.each(value, function (res) {
          that.transDiffData(res);
        });
      }
    });
    !obj.DIFF_INFO.length && delete obj.DIFF_INFO;
  },
  getBusiCommonParams: function getBusiCommonParams(busiCode, PARAM_CODE) {
    var that = this,
        custInfo = storage.$storage.getJsonSession(definecfg.$definecfg.CUSTOMER_INFO),
        busiCommonParamsFromSession = storage.$storage.getJsonLocal(definecfg.$definecfg.BUSI_COMM_PARAM),
        busiCommonParamsObjFromSession = storage.$storage.getJsonLocal(definecfg.$definecfg.BUSI_COMM_PARAM_OBJS),
        isBusiCodeChange = _.filter(busiCommonParamsFromSession, function (item) {
      return item.BUSI_CODE == busiCode;
    });
    if (_.isEmpty(busiCommonParamsFromSession) || !isBusiCodeChange.length) {
      return sysConfig.$syscfg.K_Request("F0000031", {
        BUSI_CODE: busiCode,
        USER_TYPE: custInfo && custInfo.USER_TYPE || store.state.usertype
      }).then(function (data) {
        if (data.Code == 0) {
          storage.$storage.setLocal(definecfg.$definecfg.BUSI_COMM_PARAM, data.Data);

          var busiCommonParamsObj = {};
          _.each(data.Data || [], function (obj) {
            busiCommonParamsObj[obj.PARAM_CODE] = obj.PARAM_VALUE;
          });
          storage.$storage.setLocal(definecfg.$definecfg.BUSI_COMM_PARAM_OBJS, busiCommonParamsObj);
          if (PARAM_CODE) {
            return that.getBusiCommonParamsByCode(data.Data, PARAM_CODE);
          } else {
            return data.Data;
          }
        } else {
          consoleLog("业务公共参数查询失败");
          throw "业务公共参数查询失败,原因：" + data.Msg;
        }
      });
    } else {
      return new _Promise(function (resolve, reject) {
        resolve(PARAM_CODE ? busiCommonParamsObjFromSession[PARAM_CODE] : busiCommonParamsFromSession);
      });
    }
  },
  getBusiCommonParamsByCode: function getBusiCommonParamsByCode(paramsArray, paramCode) {
    var valFilter = paramsArray.filter(function (v) {
      return v.PARAM_CODE == paramCode;
    });
    return valFilter.length > 0 && valFilter[0].PARAM_VALUE || "";
  },
  getBusiCommonParamsFromCacheObjs: function getBusiCommonParamsFromCacheObjs(paramCode) {
    var comObjs = storage.$storage.getJsonLocal(definecfg.$definecfg.BUSI_COMM_PARAM_OBJS);
    return comObjs && comObjs[paramCode] || "";
  },
  getSysCommonParamsFromCacheObjs: function getSysCommonParamsFromCacheObjs(parCOde) {
    var _this6 = this;

    return _asyncToGenerator(_regeneratorRuntime.mark(function _callee5() {
      var comObjs, res;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              comObjs = storage.$storage.getJsonLocal(definecfg.$definecfg.SYS_COMM_PARAM_OBJS) || {};

              if (!(comObjs && comObjs[parCOde])) {
                _context5.next = 5;
                break;
              }

              return _context5.abrupt("return", _Promise.resolve(comObjs[parCOde]));

            case 5:
              _context5.next = 7;
              return sysConfig.$syscfg.getSysConfig(parCOde);

            case 7:
              res = _context5.sent;

              _.each(res.Data || [], function (obj) {
                comObjs[obj.PAR_CODE] = obj.PAR_VAL;
              });
              storage.$storage.setLocal(definecfg.$definecfg.SYS_COMM_PARAM_OBJS, comObjs);
              return _context5.abrupt("return", comObjs[parCOde] || "");

            case 11:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, _this6);
    }))();
  },
  fetchCalendarInfo: function fetchCalendarInfo(params) {
    return sysConfig.$syscfg.K_Request("W0000119", _Object$assign({
      bex_codes: "L1260601"
    }, params || {})).then(function (data) {
      if (data.Code == "0") {
        return data.Data && data.Data[0] || null;
      } else {
        consoleLog("日历信息获取失败");
        throw "日历信息获取失败原因：" + data.Msg;
      }
    });
  },
  apptBizTaskSubmit: function apptBizTaskSubmit() {
    var bSno = storage.$storage.getSession(definecfg.$definecfg.B_SNO);
    if (!bSno) {
      throw "预约数据提交流水号不能为空";
    }
    return sysConfig.$syscfg.K_Request("W0000122", {
      ACCEPT_TYPE: 0,
      B_SNO: bSno
    });
  },
  updateFinallyTaskTime: function updateFinallyTaskTime(bSno, nodeKey) {
    return sysConfig.$syscfg.K_Request("P001003660", {
      B_SNO: bSno,
      NODE_KEY: nodeKey
    }, true);
  },
  acceptTaskSubmit: function acceptTaskSubmit() {
    var bSno = storage.$storage.getSession(definecfg.$definecfg.B_SNO);
    if (!bSno) {
      throw "业务受理最后一步提交流水号不能为空";
    }
    consoleLog("发起流程，ACCEPT_TYPE=1");
    return sysConfig.$syscfg.K_Request("W0000122", {
      ACCEPT_TYPE: 1,
      B_SNO: bSno
    });
  },
  acceptTaskSubmit2: function acceptTaskSubmit2() {
    var bSno = storage.$storage.getSession(definecfg.$definecfg.B_SNO);
    if (!bSno) {
      throw "业务受理提交至受理提交中流水号不能为空";
    }
    consoleLog("发起流程，ACCEPT_TYPE=2");
    return sysConfig.$syscfg.K_Request("W0000122", {
      ACCEPT_TYPE: 2,
      B_SNO: bSno
    });
  },
  acceptTaskSubmit4: function acceptTaskSubmit4() {
    var bSno = storage.$storage.getSession(definecfg.$definecfg.B_SNO);
    if (!bSno) {
      throw "业务受理提交至待审核流水号不能为空";
    }
    consoleLog("发起流程，ACCEPT_TYPE=4");
    return sysConfig.$syscfg.K_Request("W0000122", {
      ACCEPT_TYPE: 4,
      B_SNO: bSno
    });
  },
  W0000215: function W0000215(param) {
    return sysConfig.$syscfg.K_Request("W0000215", param);
  },
  F0000034: function F0000034(param) {
    var preDataCache = storage.$storage.getJsonLocal(definecfg.$definecfg.PRE_MODULE_DATA_CACHE);
    if (!preDataCache) {
      return sysConfig.$syscfg.K_Request("F0000034", param).then(function (res) {
        if (res.Code == "0" && res.Data && res.Data.length) {
          storage.$storage.setLocal(definecfg.$definecfg.PRE_MODULE_DATA_CACHE, res);
        }
        return res;
      });
    } else {
      return new _Promise(function (resolve, reject) {
        resolve(preDataCache);
      });
    }
  },
  F0000028: function F0000028(param) {
    var preGroupDataCache = storage.$storage.getJsonLocal(definecfg.$definecfg.PRE_GROUP_DATA_CACHE);
    if (!preGroupDataCache) {
      return sysConfig.$syscfg.K_Request("F0000028", param).then(function (res) {
        consoleLog("重新请求了F0000028");
        if (res.Code == "0" && res.Data && res.Data.length) {
          storage.$storage.setLocal(definecfg.$definecfg.PRE_GROUP_DATA_CACHE, res);
        }
        return res;
      });
    } else {
      return new _Promise(function (resolve, reject) {
        resolve(preGroupDataCache);
      });
    }
  },
  checkSysVersion: function checkSysVersion(param) {
    return sysConfig.$syscfg.K_Request("F0000000", {
      SERVICE_CODE: "QS4000015",
      LOCAL_VERSION: param.LOCAL_VERSION,
      DEVICE_ID: param.DEVICE_ID
    }).then(function (res) {
      return res.Data[0];
    });
  }
};


//////////////////
// WEBPACK FOOTER
// ./src/service/opp-service.js
// module id = 11
// module chunks = 2